import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
    id: "users",
    class: "flex items-center mb-4"
};
const _hoisted_2 = { class: "ml-2" };
const _hoisted_3 = {
    key: 0,
    class: "admin-table"
};
const _hoisted_4 = { class: "colored-row" };
const _hoisted_5 = { class: "w-16" };
const _hoisted_6 = ["aria-labelledby", "id"];
const _hoisted_7 = { class: "font-medium" };
const _hoisted_8 = { class: "block" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = {
    key: 1,
    class: "block"
};
const _hoisted_11 = { key: 0 };
const _hoisted_12 = { class: "font-medium" };
const _hoisted_13 = { class: "block" };
const _hoisted_14 = { class: "block" };
const _hoisted_15 = { key: 0 };
const _hoisted_16 = { key: 1 };
const _hoisted_17 = { class: "text-right" };
const _hoisted_18 = ["onClick", "disabled"];
const _hoisted_19 = ["onClick"];
const _hoisted_20 = { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" };
const _hoisted_21 = { class: "text-lg leading-6 font-medium text-slate-900" };
const _hoisted_22 = { class: "my-loading" };
const _hoisted_23 = { class: "no-results panel p-10 mt-4" };
const _hoisted_24 = { class: "text-center mt-4 text-sm text-slate-700" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_form_message = _resolveComponent("form-message");
    const _component_router_link = _resolveComponent("router-link");
    const _component_report_search = _resolveComponent("report-search");
    const _component_ConfirmationModal = _resolveComponent("ConfirmationModal");
    const _component_Loading = _resolveComponent("Loading");
    const _component_VueEternalLoading = _resolveComponent("VueEternalLoading");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _cache[2] || (_cache[2] = _createElementVNode("h1", null, "Users", -1)),
            _createVNode(_component_form_message, { form: _ctx.form }, null, 8, ["form"]),
            _createElementVNode("nav", _hoisted_2, [
                (_ctx.permissions.isProgrammeManager())
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: { name: 'admin.user.invite' },
                        class: "btn"
                    }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                _createTextVNode(" Invite User ", -1)
                            ]))]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ])
        ]),
        _createVNode(_component_report_search, {
            searchFilters: ['name', 'email', 'account'],
            default: "email",
            onSearch: _ctx.search
        }, null, 8, ["onSearch"]),
        (_ctx.index.hasResults())
            ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
                _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                            _createElementVNode("table", null, [
                                _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("th", { scope: "col" }, " "),
                                        _createElementVNode("th", { scope: "col" }, "Name / Email"),
                                        _createElementVNode("th", { scope: "col" }, "Role"),
                                        _createElementVNode("th", { scope: "col" }, " "),
                                        _createElementVNode("th", {
                                            scope: "col",
                                            class: "text-right"
                                        }, "Action")
                                    ])
                                ], -1)),
                                _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.index.getData(), (user) => {
                                        return (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                                            _createElementVNode("td", _hoisted_5, [
                                                (_openBlock(), _createElementBlock("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    class: "h-10 w-10 text-slate-400 mx-auto",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    role: "img",
                                                    focusable: "false",
                                                    "aria-labelledby": user.id,
                                                    id: user.id
                                                }, [...(_cache[3] || (_cache[3] = [
                                                        _createElementVNode("title", null, "User", -1),
                                                        _createElementVNode("path", {
                                                            "stroke-linecap": "round",
                                                            "stroke-linejoin": "round",
                                                            d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                                                        }, null, -1)
                                                    ]))], 8, _hoisted_6))
                                            ]),
                                            _createElementVNode("td", _hoisted_7, [
                                                (_ctx.permissions.isProgrammeManager() && user.deleted_at === null)
                                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                                        key: 0,
                                                        to: { name: 'admin.user.update', params: { id: user.id } }
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("span", _hoisted_8, [
                                                                _createTextVNode(_toDisplayString(user.name) + " ", 1),
                                                                (user.account)
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, "(" + _toDisplayString(user.account) + ")", 1))
                                                                    : _createCommentVNode("", true)
                                                            ])
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["to"]))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                                        _createTextVNode(_toDisplayString(user.name) + " ", 1),
                                                        (user.account)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, "(" + _toDisplayString(user.account) + ")", 1))
                                                            : _createCommentVNode("", true)
                                                    ])),
                                                _createElementVNode("span", null, _toDisplayString(user.email), 1)
                                            ]),
                                            _createElementVNode("td", _hoisted_12, [
                                                _createElementVNode("span", _hoisted_13, _toDisplayString(user.role), 1)
                                            ]),
                                            _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_14, [
                                                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "font-medium" }, "Invited:", -1)),
                                                    _createTextVNode(" " + _toDisplayString(_ctx.f.formatDateShort(user.created_at)), 1)
                                                ]),
                                                (user.deleted_at)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "font-medium" }, "Deleted:", -1)),
                                                        _createTextVNode(" " + _toDisplayString(_ctx.f.formatDateShort(user.deleted_at)), 1)
                                                    ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "font-medium" }, "Last Updated:", -1)),
                                                        _createTextVNode(" " + _toDisplayString(_ctx.f.formatDateShort(user.updated_at)), 1)
                                                    ]))
                                            ]),
                                            _createElementVNode("td", _hoisted_17, [
                                                _createElementVNode("nav", null, [
                                                    (_ctx.permissions.isProgrammeManager())
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 0,
                                                            type: "button",
                                                            class: "dark ml-2 mb-2 text-xs",
                                                            onClick: ($event) => (_ctx.form.resendInvite(user)),
                                                            disabled: user.deleted_at || _ctx.$props.app.auth.id === user.id
                                                        }, "Resend Invite", 8, _hoisted_18))
                                                        : _createCommentVNode("", true),
                                                    (_ctx.permissions.isProgrammeManager() && user.deleted_at)
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 1,
                                                            type: "button",
                                                            class: "dark ml-2 mb-2 text-xs",
                                                            onClick: ($event) => (_ctx.form.restore(user))
                                                        }, "Restore", 8, _hoisted_19))
                                                        : (_ctx.permissions.isProgrammeManager())
                                                            ? (_openBlock(), _createBlock(_component_ConfirmationModal, {
                                                                key: 2,
                                                                id: String(user.id),
                                                                buttonClass: "error ml-2 text-xs",
                                                                buttonText: "Delete",
                                                                buttonDisabled: _ctx.$props.app.auth.id === user.id,
                                                                onConfirmAction: ($event) => (_ctx.form.delete(user)),
                                                                class: "inline-flex"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-brand-100 sm:mx-0 sm:h-10 sm:w-10" }, [
                                                                        _createElementVNode("svg", {
                                                                            class: "h-6 w-6 text-brand-600",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            fill: "none",
                                                                            viewBox: "0 0 24 24",
                                                                            stroke: "currentColor",
                                                                            role: "img",
                                                                            focusable: "false",
                                                                            "aria-label": "Warning"
                                                                        }, [
                                                                            _createElementVNode("path", {
                                                                                "stroke-linecap": "round",
                                                                                "stroke-linejoin": "round",
                                                                                "stroke-width": "2",
                                                                                d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                                                            })
                                                                        ])
                                                                    ], -1)),
                                                                    _createElementVNode("div", _hoisted_20, [
                                                                        _createElementVNode("h3", _hoisted_21, "Delete `" + _toDisplayString(user.name) + "`?", 1),
                                                                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "mt-2" }, [
                                                                            _createElementVNode("p", { class: "text-sm text-slate-500" }, " Are you sure you would like to delete this account? Deleting this account will prevent its owner from logging in. ")
                                                                        ], -1))
                                                                    ])
                                                                ]),
                                                                _: 2
                                                            }, 1032, ["id", "buttonDisabled", "onConfirmAction"]))
                                                            : _createCommentVNode("", true)
                                                ])
                                            ])
                                        ]));
                                    }), 256))
                                ])
                            ])
                        ])
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        _createVNode(_component_VueEternalLoading, {
            load: _ctx.load,
            "is-initial": _ctx.isInitial,
            "onUpdate:isInitial": _cache[0] || (_cache[0] = ($event) => ((_ctx.isInitial) = $event))
        }, {
            loading: _withCtx(() => [
                _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_Loading, { message: "Loading Users" })
                ])
            ]),
            "no-more": _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createElementVNode("div", { class: "my-no-more" }, [
                        _createElementVNode("div", { class: "my-6 text-center" }, [
                            _createElementVNode("a", {
                                href: "#users",
                                class: "flex justify-center"
                            }, [
                                _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    class: "h-5 w-5 mr-2",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    focusable: "true"
                                }, [
                                    _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        d: "M5 10l7-7m0 0l7 7m-7-7v18"
                                    })
                                ]),
                                _createTextVNode(" Top of Page ")
                            ])
                        ])
                    ], -1)
                ]))]),
            "no-results": _withCtx(() => [
                _createElementVNode("div", _hoisted_23, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-slate-300 my-6" }, [
                        _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            class: "h-20 w-20 mx-auto",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            role: "img",
                            focusable: "false",
                            "aria-label": "No Users Available"
                        }, [
                            _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                            })
                        ])
                    ], -1)),
                    _cache[15] || (_cache[15] = _createElementVNode("h2", { class: "text-slate-600 font-medium text-2xl text-center" }, "No Users Available", -1)),
                    _createElementVNode("p", _hoisted_24, [
                        _cache[12] || (_cache[12] = _createTextVNode(" We could not find any users, ", -1)),
                        _createVNode(_component_router_link, { to: { name: 'admin.user.invite' } }, {
                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                    _createTextVNode("create one", -1)
                                ]))]),
                            _: 1
                        }),
                        _cache[13] || (_cache[13] = _createTextVNode(". ", -1))
                    ])
                ])
            ]),
            error: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("div", { class: "no-results panel p-10 mt-4" }, [
                        _createElementVNode("div", { class: "text-slate-300 my-6" }, [
                            _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-20 w-20 mx-auto",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                role: "img",
                                focusable: "false",
                                "aria-label": "An Error Occurred"
                            }, [
                                _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                })
                            ])
                        ]),
                        _createElementVNode("h2", { class: "text-slate-600 font-medium text-2xl text-center" }, "An Error Occurred"),
                        _createElementVNode("p", { class: "text-center mt-4 text-sm text-slate-700" }, " An error occurred, please try again. If this problem persists please contact support. ")
                    ], -1)
                ]))]),
            _: 1
        }, 8, ["load", "is-initial"])
    ], 64));
}
